// extracted by mini-css-extract-plugin
export default {"sendButton":"style_sendButton__mqzzf"};